module.exports = __webpack_public_path__ + "img/carousel4.0e32060a.png";